// extracted by mini-css-extract-plugin
module.exports = {"lia-edit-btn":"FeaturedContentWidget_lia-edit-btn__LtjRk"};